import React from 'react';
import { Shield, Search, Zap, Globe, Server, Lock, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
export function Features() {
  const features = [{
    id: 'monitoring',
    title: 'Real-Time Network Monitoring',
    description: 'Get instant visibility into network performance with sub-millisecond granularity. Track latency, jitter, and packet loss across your entire infrastructure.',
    icon: <Zap className="h-6 w-6 text-cyan-400" data-id="element-175" />,
    points: ['Sub-millisecond updates', 'Global latency tracking', 'Bandwidth utilization analysis']
  }, {
    id: 'security',
    title: 'Advanced Threat Detection',
    description: 'Leverage machine learning models trained on petabytes of network data to identify and block security threats before they impact your business.',
    icon: <Shield className="h-6 w-6 text-cyan-400" data-id="element-176" />,
    points: ['DDoS mitigation', 'Anomaly detection', 'Zero-day threat identification']
  }, {
    id: 'inspection',
    title: 'Deep Packet Inspection',
    description: 'Drill down into individual packets to troubleshoot complex connectivity issues. Filter, capture, and analyze traffic with surgical precision.',
    icon: <Search className="h-6 w-6 text-cyan-400" data-id="element-177" />,
    points: ['Protocol analysis', 'Payload inspection', 'Traffic filtering & capture']
  }];
  return <div className="min-h-screen bg-slate-950" data-id="element-178">
      {/* Header */}
      <section className="py-20 border-b border-slate-800" data-id="element-179">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-180">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-181">
            Platform Capabilities
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-182">
            Explore the powerful features that make njgod the choice for
            enterprise network teams.
          </p>
        </div>
      </section>

      {/* Feature Sections */}
      <div className="space-y-24 py-24" data-id="element-183">
        {features.map((feature, idx) => <section key={feature.id} className="relative" data-id="element-184">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
              <div className={`flex flex-col items-center text-center max-w-3xl mx-auto`} data-id="element-186">
                {/* Content */}
                <div className="w-full" data-id="element-187">
                  <div className="inline-flex items-center justify-center p-3 bg-slate-900 rounded-xl mb-6 border border-slate-800" data-id="element-188">
                    {feature.icon}
                  </div>
                  <h2 className="text-3xl font-bold text-white mb-4" data-id="element-189">
                    {feature.title}
                  </h2>
                  <p className="text-slate-400 text-lg mb-8 leading-relaxed" data-id="element-190">
                    {feature.description}
                  </p>
                  <ul className="space-y-4 mb-8" data-id="element-191">
                    {feature.points.map((point, i) => <li key={i} className="flex items-center justify-center text-slate-300" data-id="element-192">
                        <div className="h-1.5 w-1.5 rounded-full bg-cyan-500 mr-3" data-id="element-193"></div>
                        {point}
                      </li>)}
                  </ul>
                  <Link to="/contact" data-id="element-194">
                    <Button variant="outline" rightIcon={<ArrowRight className="h-4 w-4" data-id="element-196" />} data-id="element-195">
                      Learn more
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </section>)}
      </div>

      {/* Tech Specs Grid */}
      <section className="py-24 bg-slate-900/30 border-t border-slate-800" data-id="element-197">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-199">
            Technical Specifications
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-200">
            {[{
            title: 'Data Retention',
            value: 'Up to 365 Days'
          }, {
            title: 'Query Speed',
            value: '< 50ms Average'
          }, {
            title: 'Ingestion Rate',
            value: '1M+ Events/Sec'
          }, {
            title: 'API Availability',
            value: '99.999% SLA'
          }, {
            title: 'Encryption',
            value: 'AES-256 at Rest'
          }, {
            title: 'Compliance',
            value: 'SOC2, GDPR, HIPAA'
          }, {
            title: 'Integrations',
            value: '50+ Native Connectors'
          }, {
            title: 'Support',
            value: '24/7 Dedicated'
          }].map((spec, idx) => <div key={idx} className="bg-slate-950 border border-slate-800 p-6 rounded-xl hover:border-cyan-500/50 transition-colors" data-id="element-201">
                <div className="text-slate-500 text-sm mb-2" data-id="element-202">{spec.title}</div>
                <div className="text-xl font-semibold text-white" data-id="element-203">
                  {spec.value}
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}